export const formatPriceOld = (priceValue = 0) => {
  if (priceValue === 0) {
    return 0;
  }

  const price = parseFloat(priceValue);
  const [integerPart, decimalPart = '00'] = price
    .toFixed(2)
    .toString()
    .split('.');

  if (integerPart.length <= 3) {
    return `${integerPart}.${decimalPart}`;
  }

  const lastThreeDigits = integerPart.slice(-3);
  let remainingDigits = integerPart.slice(0, -3);

  remainingDigits = remainingDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ',');

  return `${remainingDigits},${lastThreeDigits}.${decimalPart}`;
};

// savings calculate
export const calculateSavingsPercentage = (price, discountedPrice) => {
  if (price <= 0 || discountedPrice < 0 || discountedPrice > price) {
    return null;
  }

  const savings = price - discountedPrice;
  const savingsPercentage = (savings / price) * 100;

  return Math.round(savingsPercentage);
};

// cart total items calculate
export const calculateCartTotalQuantity = (cart) => {
  if (cart.length === 0) return 0;

  return cart.reduce((total, item) => total + item.stockQtty, 0);
};

export const calculateEmiPrice = (salePrice = 0, emiMonth = 12) => {
  // Validate inputs
  if (!salePrice || salePrice <= 0) return 0;

  // Convert to numbers
  const price = Number(salePrice);
  const months = Number(emiMonth);

  // Calculate monthly EMI (without interest for now)
  const monthlyAmount = price / months;

  // Round to 2 decimal places
  return Math.round(monthlyAmount);
};

export const floorToNearestHalf = (num) => Math.floor(num * 2) / 2;

export const getCurrentProductPrice = (productData) => {
  // USE THIS FOR PRICE subtotal
  if (productData?.discount) {
    return productData?.discount?.offer_price;
  }

  return productData?.regular_price;
};

// ignore last digit zero after decimal point
export const formatPrice = (priceValue = 0) => {
  if (priceValue === 0) {
    return 0;
  }

  const price = parseFloat(priceValue);
  const formattedPrice = price.toFixed(2);
  const [integerPart, decimalPart] = formattedPrice.split('.');

  if (integerPart.length <= 3) {
    return decimalPart === '00' ? integerPart : `${formattedPrice}`;
  }

  const lastThreeDigits = integerPart.slice(-3);
  let remainingDigits = integerPart.slice(0, -3);

  remainingDigits = remainingDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ',');

  return decimalPart === '00'
    ? `${remainingDigits},${lastThreeDigits}`
    : `${remainingDigits},${lastThreeDigits}.${decimalPart}`;
};

export const formatPhoneNumber = (phone) => phone.replace(/^\+880/, '');

export const getSubTotalPrice = (items) => {
  let subTotalPrice = 0;

  if (items?.length === 0) {
    return subTotalPrice;
  }

  items?.forEach((item) => {
    const itemStockQuantity = Number(item?.quantity);

    subTotalPrice += getCurrentProductPrice(item) * itemStockQuantity;
  });

  return subTotalPrice;
};

export const getStockAddableQuantity = ({ cart, productId, maxQuantity }) => {
  if (!cart || !productId || maxQuantity <= 0) {
    return 0;
  }

  const cartItem = cart.find((item) => item.id === productId);
  const currentQuantity = cartItem ? cartItem.cart_quantity : 0;

  if (currentQuantity === undefined) {
    return maxQuantity;
  }

  // Return remaining quantity that can be added
  const remainingQuantity = maxQuantity - currentQuantity;
  return remainingQuantity > 0 ? remainingQuantity : 0;
};

export const getProductPriceWithDiscountText = (priceObj) => {
  const offerPrice = Number(priceObj?.final_price);
  const regularPrice = Number(priceObj?.regular_price);

  if (offerPrice === regularPrice) {
    return { price: 0, text: '' };
  }

  return { price: regularPrice, text: priceObj?.discount?.discount_text };
};
